import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Box, Stack } from '@mui/material';
import { UserOccupation } from '@travelity/api';

import { get } from 'lodash';
import { ReactComponent as GuideIcon } from '../assets/guide.svg';
import { ReactComponent as DriverIcon } from '../assets/driver.svg';
import { ReactComponent as TourAgentIcon } from '../assets/tour-agent.svg';

export interface OccupationSelectProps {
    name: string;
    showErrors?: boolean;
}

export const occupations = [
    {
        label: 'Guide',
        value: UserOccupation.GUIDE,
        description: 'Guide description',
        icon: GuideIcon,
    },
    {
        label: 'Driver',
        value: UserOccupation.DRIVER,
        description: 'Driver description',
        icon: DriverIcon,
    },
    {
        label: 'Travel Agent',
        value: UserOccupation.TRAVEL_AGENT,
        description: 'Travel Agent description',
        icon: TourAgentIcon,
    },
];

const OccupationSelect: React.FC<OccupationSelectProps> = ({
    name,
    showErrors,
}) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();
    const {
        field: { value, onChange },
    } = useController({
        name,
        control,
    });

    const error =
        showErrors && (get(errors, name)?.message as string | undefined);

    return (
        <Stack
            direction="row"
            justifyContent={{ xs: 'space-between', sm: 'center' }}
            gap={1}
            sx={{
                py: '3px',
                px: 1,
                width: { xs: 1, sm: 'auto' },
                // transform: { xs: 'scale(0.5)', sm: undefined },
            }}
        >
            {occupations.map(option => (
                <Stack
                    key={option.value}
                    justifyContent="center"
                    alignItems="center"
                    gap={1}
                    sx={{
                        width: { xs: 'calc(33% - 5px)', sm: '240px' },
                        height: { xs: '140px', sm: '216px' },
                        borderRadius: '8px',
                        bgcolor: '#F4F6FA',
                        cursor: 'pointer',
                        border:
                            value === option.value
                                ? '2px solid #55B5CF'
                                : '2px solid #F4F6FA',
                        ...(!!error && {
                            borderWidth: '2px',
                            borderColor: 'error.main',
                        }),
                    }}
                    onClick={() => onChange(option.value)}
                >
                    <Box sx={{ m: 2 }} component={option.icon} />
                    <Box
                        sx={{
                            color: '#2B395B',
                            fontSize: '14px',
                            fontWeight: '700',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {option.label}
                    </Box>
                    <Box
                        sx={{
                            color: '#2B395B',
                            fontSize: { xs: '12px', sm: '14px' },
                            fontWeight: '400',
                            lineHeight: '100%',
                            opacity: '0.5',
                            textAlign: 'center',
                            pb: 1,
                        }}
                    >
                        {option.description}
                    </Box>
                </Stack>
            ))}
        </Stack>
    );
};

export default OccupationSelect;
